import {
  GET_DELIVERYS_ZONE_SUCCESS,
  GET_CITIES_SUCCESS,
  GET_SECTORS_SUCCESS,
  SET_DELIVERY_ZONE,
  SET_SECTORS_SELECTED,
  DELETE_SECTORS,
  GET_SECTORS,
  GET_SHIPPING_RULES,
  DELETE_SHIPPING_RULES,
  CREATE_DELIVERYS_ZONE_SUCCESS,
  GET_ALL_SHIPPING_RULES_SUCCESS,
  SET_STORE_SUCCESS,
  SET_EDIT_MODE_SUCCESS,
  GET_SHIPPING_RULES_DELETED,
  GET_DELIVERYS_ZONE,
  GET_ALL_SHIPPING_RULES,
  EDIT_DELIVERYS_ZONE_SUCCESS,
  EDIT_DELIVERYS_ZONE,
  DELETE_DELIVERYS_ZONE_SUCCESS,
  CREATE_DELIVERYS_ZONE
} from "../constants/dynamicShippingType";

const initialState = {
  deliveryZone: {},
  deliveryZones: [],
  cities: [],
  shippingRules: [],
  allShippingRules: [],
  sectorsByCitySelected: [],
  listSectorSelected: [],
  storeSelected: {},
  isItEditing: false,
  loading: false
};

export const dynamicShippingReducer = (state = initialState, { data, error, type }) => {
  switch (type) {
    case SET_DELIVERY_ZONE:
      return {
        ...state,
        deliveryZone: data
      }
    case GET_DELIVERYS_ZONE:
      return {
        ...state,
        loading: true
      }
    case GET_DELIVERYS_ZONE_SUCCESS:
      return {
        ...state,
        deliveryZones: data.results,
        loading: false
      }
    case CREATE_DELIVERYS_ZONE:
      return {
        ...state,
        loading: true
      }
    case CREATE_DELIVERYS_ZONE_SUCCESS:
      return {
        ...state,
        deliveryZones: [data, ...state.deliveryZones],
        loading: false

      }
    case EDIT_DELIVERYS_ZONE:
      return {
        ...state,
        loading: true
      }
    case EDIT_DELIVERYS_ZONE_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case DELETE_DELIVERYS_ZONE_SUCCESS:
      const deliveryToDelete = state.deliveryZones.map(delivery => delivery.id).indexOf(data);
      const newDeliveryZone = state.deliveryZones
      newDeliveryZone.splice(deliveryToDelete, 1)
      return {
        ...state,
        deliveryZones: newDeliveryZone
      }
    case GET_SHIPPING_RULES:
      let dataState = state.shippingRules
      if(data[0] && data[0].id) {
        const index = dataState.map(i => i.id).indexOf(data[0].id);
        dataState.splice(index, 1)
      } else {
        const index = dataState.map(i =>i.shipping_type).indexOf(data[0].shipping_type)
        if(index >= 0) {
          dataState.splice(index, 1)
        } 
      }
      return {
        ...state,
        shippingRules: [
          ...dataState,
          ...data
        ]
      }
    case GET_SHIPPING_RULES_DELETED:
      let rules  = state.shippingRules
      let allRules  = state.allShippingRules
      if(typeof(data) === 'number' ){
        const indexRule = state.shippingRules.findIndex(i => i.id === data)
        const indexRules = state.allShippingRules.findIndex(i => i.id === data)
        indexRule >= 0 && rules.splice(indexRule, 1)
        indexRules >= 0 && allRules.splice(indexRules, 1)
      } else {
        const indexRule = state.shippingRules.findIndex(i => i.shipping_type === data)
        indexRule >= 0 && rules.splice(indexRule, 1)
      }     
      return {
        ...state,
        shippingRules: data ? rules : [],
        allShippingRules: data ? allRules : state.allShippingRules
      }
    case GET_ALL_SHIPPING_RULES:
      return {
        ...state,
        loading: true
        
      }
    case GET_ALL_SHIPPING_RULES_SUCCESS:
      return {
        ...state,
        allShippingRules: data.results,
        loading: false
        
      }
    case DELETE_SHIPPING_RULES:
      return {
        ...state,
        shippingRules: []
      }
    case GET_CITIES_SUCCESS:
      if (state.cities) {
        return {
          ...state,
          cities: data.results
        }
      }
    case GET_SECTORS:
      return {
        ...state,
        loading: true
      }
    case GET_SECTORS_SUCCESS:
      return {
        ...state,
        sectorsByCitySelected: data.results,
        loading: false
      }
    case DELETE_SECTORS:
      return {
        ...state,
        sectorsByCitySelected: []
      }
    case SET_SECTORS_SELECTED:
      return {
        ...state,
        listSectorSelected: data
      }
    case SET_STORE_SUCCESS:
      return {
        ...state,
        storeSelected: data
      }
    case SET_EDIT_MODE_SUCCESS:
      return {
        ...state,
        isItEditing: data
      }
    default:
      return state;
  }
};
